import './ManifestoMain.css';

function ManifestoMain() {
  return (
    <div className="ManifestoMain">
       <div id="introduçao">
            <h2>Introdução</h2>
            <p>
            A Lista E apresenta, mais uma vez, a sua candidatura à Associação de Estudantes da
        Faculdade de Engenharia da Universidade do Porto.
            </p>
    <p>
    No passado ano letivo de 2020/2021, surgimos como uma lista alternativa, quebrando a
tendência da lista única candidata aos órgãos sociais da AEFEUP, procurando fomentar a
envolvência dos estudantes na vida da sua Associação. Este ano, o projeto continua, pois
não desistimos de trazer a democracia à nossa faculdade e não nos conformamos com
uma Associação de Estudantes meramente focada em eventos e burocracias. Um dos seus
focos deve ser, como referem os seus próprios estatutos, representar e defender os
interesses dos estudantes.
    </p>
    <p>
    Pretendemos, acima de tudo, contribuir para a reflexão dos estudantes acerca do papel e
trabalho da AEFEUP. Somos contra o conformismo.
</p>
<p>
Queremos construir uma Associação próxima dos estudantes e das suas realidades, que
crie e promova a discussão aberta e o conhecimento ativo dos problemas da FEUP.
Queremos construir uma AEFEUP que seja intransigente na defesa dos direitos dos
estudantes da faculdade. Defendemos que é necessário ir muito além de inquéritos e que é
urgente fazer um esforço real e ativo para envolver os estudantes na atividade da AEFEUP.
Para a Lista E, este deve ser o local onde ouvimos, somos ouvidos e nos fazemos ouvir.
</p>
<p>
Queremos uma AEFEUP que esteja na primeira linha da defesa dos seus estudantes. Uma
AEFEUP que assuma o seu papel, enquanto maior Associação de Estudantes da Academia
do Porto, rejeitando a ideia de que a nossa voz não se levanta ou de que a nossa força não
chega. Queremos uma Associação que saiba de que lado está e que seja o espelho da
irreverência e coragem dos estudantes de Engenharia.
</p>
<p>
Desde o início da pandemia da COVID-19 que não faltaram ataques aos direitos dos
estudantes. Passámos por um gigante período de aulas à distância, no qual não foram
asseguradas as condições básicas ao estudo. Não nos esquecemos dos estudantes que
não têm condições materiais ou um espaço de estudo saudável em casa. Não nos
esquecemos que nos foi retirado o acesso às salas de estudo da FEUP, que foi limitado o
horário e o acesso à biblioteca da FEUP. E sabemos, também, que foi apenas através do
descontentamento e das reivindicações dos estudantes que reconquistámos alguns dos
nossos direitos. Desde o início da pandemia que se tornou ainda mais urgente que a AEFEUP
assumisse prontamente o lado dos seus estudantes.
</p>
<p>
Reconhecemos, no entanto, que as dificuldades que conhecemos não surgiram com a
pandemia, mas foram sim agravadas por esta. Desde logo, rejeitamos a propina,
identificando-a como principal entrave ao ingresso ao Ensino Superior. Reclamamos o
direito a estudar, o direito dos jovens a verem cumpridas as suas ambições. Defendemos
uma reforma no financiamento das Instituições de Ensino Superior público, que não
contemple o pagamento de propinas, taxas e emolumentos, que não veja nos estudantes
um cliente. Uma Associação de Estudantes que não rejeite que o Ensino Superior seja
financiado à custa dos mesmos, não pode afirmar defender os nossos interesses.
Solidarizamo-nos com todos os estudantes internacionais que viram as suas propinas
aumentadas ao longo dos últimos anos, enquanto eram reduzidas as propinas de 1o ciclo
dos estudantes nacionais.
</p>
<p>
Opusemo-nos à desintegração dos Mestrados Integrados, tal como nos opomos, hoje, ao
agressivo aumento da propina de 2o ciclo na FEUP. Uma formação adequada em
Engenharia não pode cingir-se a apenas três anos. Na nossa área, um Mestrado é
fundamental para o exercício da profissão, tal como é reconhecido pela Ordem dos
Engenheiros. A desintegração dos Mestrados Integrados não só permitiu um recente
aumento da propina de Mestrado, como nós previmos ainda no programa do ano passado,
como dificulta o acesso a este ciclo de estudos. Este aumento contraria claramente o
direito a um ensino acessível a todos e progressivamente gratuito, tal como consta da
Constituição da República.
</p>
<p>
É urgente pressionar as instituições no sentido de repor a propina do 2o ciclo de estudos,
voltando a equipará-lo ao da Licenciatura, para que nenhum de nós seja obrigado a ficar
pelo caminho. O caminho para que sejamos ouvidos passa pela luta e reivindicação dos
nossos direitos, e é o papel da Associação de Estudantes encabeçar este movimento,
representando-nos em todas as frentes necessárias e procurando todo o apoio possível
para a concretização deste objetivo.
</p>
<p>
Mais uma vez, o nosso programa assenta em <strong> três pilares fundamentais</strong>, que acreditamos
serem o ponto de partida para uma FEUP e um Ensino Superior saudáveis:
</p>
       </div>
       <div id="ensino-para-todos">
       <h2>Ensino Para Todos</h2>
           <p>
           O Ensino Superior não deve ter barreiras. A FEUP deve ser uma faculdade inclusiva e
em que todos sejamos respeitados e tratados como os iguais que somos. Rejeitamos
o machismo, a homofobia, a xenofobia, o racismo e todos os entraves económicos
ao estudo. Não esquecemos os trabalhadores-estudantes, que não devem ficar de
parte das decisões sobre a avaliação e o funcionamento da faculdade.
Trabalharemos em prol de um ambiente de igualdade e para que o interesse dos
estudantes seja a linha orientadora da nossa ação, sem qualquer tipo de receio de
nos impor perante quem seja.<strong>Somos contra a propina e quaisquer taxas e
emolumentos.</strong> 
           </p>
       </div>
       <div id="ensino-com-dignidade">
       <h2>Ensino Com Dignidade</h2>
        <p>
        A qualidade da formação dos estudantes de engenharia é essencial para o nosso
futuro e deve ser assegurada, garantindo as condições dignas para que se consigam
obter melhores resultados, sem descuidar os momentos de lazer, a fruição e
produção cultural ou a prática de desporto, por exemplo. Para isto, é imprescindível a
disponibilidade de locais de estudo, horários adequados a todos os membros da
faculdade e professores dedicados. O acesso ao mestrado, como ciclo fundamental
à nossa formação, será uma prioridade. Por outro lado, momentos de lazer e convívio,
a promoção da cultura nas suas mais variadas vertentes e o fomento da prática
desportiva marcarão fortemente a nossa linha de ação.<strong> Lutaremos sempre no
sentido de avançar, e nunca recuar, os direitos e as ambições dos estudantes.</strong>
        </p>
       </div>
       <div>
           <h2 id="ensino-democratico">Ensino Democrático</h2>
           <p>
           Os estudantes são os principais interessados num ensino de qualidade, uma vez que
    isso beneficiará o seu futuro como profissionais, mas também como cidadãos. Ora,
    estes devem ser ouvidos nas decisões que os influenciam. Isto só será possível
    envolvendo todos os estudantes na construção das soluções, <strong>fazendo com que as
    suas preocupações sejam ouvidas ao longo de todo o ano, e não apenas em alguns
    momentos.</strong> Assim, propomos um processo de recrutamento aberto a todos,
    possibilitando que qualquer um trabalhe connosco na construção de uma
    Associação de Estudantes mais justa. Por outro lado, é também imperioso que os
    estudantes sejam representados e ouvidos nos órgãos de decisão da UP e da FEUP. É
    também por isto que<strong> rejeitamos o atual Regime Jurídico do Ensino Superior e o
    Regime Fundacional da Universidade do Porto.</strong> Com eles, há mais entidades
    privadas do que estudantes nos principais órgãos de gestão da UP e uma reduzida
    democracia nas faculdades, para além de obrigar as instituições a obter
    financiamento próprio, condicionando não só a qualidade e acessibilidade do ensino
    mas também a sua autonomia condenando-as a interesses privados.
           </p>
       </div>
       
    
    </div>
  );
}

export default ManifestoMain;